module.exports = __webpack_public_path__ + "static/media/sort-alpha-asc.9501867a.svg";